import React from "react";
import { Button } from "semantic-ui-react";
import { cleanRegister } from "../../../../app/store/actions/registerActions";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const actions = {
  cleanRegister,
};

const RegisterCancel = ({ cleanRegister }) => {
  return (
    <Button
      fluid
      size="large"
      color="blue"
      content="Cancelar"
      onClick={() => cleanRegister()}
      as={Link}
      to="/"
    />
  );
};
RegisterCancel.propTypes = {
  cleanRegister: PropTypes.func.isRequired,
};
export default connect(null, actions)(RegisterCancel);
